import { Component } from '@angular/core';
import { ToasterConfig } from 'angular2-toaster';


@Component({
  selector: 'app-dashboard',
  templateUrl: './admin-layout.component.html',
})
export class AdminLayoutComponent {
  public toasterconfig: ToasterConfig =
    new ToasterConfig({
      tapToDismiss: true,
      timeout: 5000
    });
}


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/containers/admin-layout/admin-layout.component.ts